export function getAmazonImageURL(countryCode, ASIN) {
    if (countryCode == 'AU') {
        countryCode = 'US'
    }

    const regionAddresses = {
        'US': 'ws-na',
        'UK': 'ws-eu',
        'DE': 'ws-eu',
        'FR': 'ws-eu',
        'JP': 'ws-fe',
        'IT': 'ws-eu',
        'ES': 'ws-eu',
        // 'MX': 'ws-na',
        'CA': 'ws-na',
        'AU': 'ws-fe'
    };

    if (!regionAddresses.hasOwnProperty(countryCode)) {
        return `https://images.amazon.com/images/P/${ASIN}.01._SCLZZZZZZZ_.jpg`;
    }

    const regionAddress = regionAddresses[countryCode];
    const imageURL = `https://${regionAddress}.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=${countryCode}&ASIN=${ASIN}&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=SL250`;

    return imageURL;
}